export const DownloadAddUsersExample = () => {
  const csvData = `"Nome: Preencha o nome do usuário.\nPode-se utilizar acentos.\nESTE CAMPO É OBRIGATÓRIO","E-MAIL: Preencha o e-mail do usuário.\nESTE CAMPO É OBRIGATÓRIO"
  "jane doe","jane@doe.com"
  "john doe","john@doe.com"
  "jane doe","jane@doe.com"
  "john doe","john@doe.com"
  "jane doe","jane@doe.com"`;

  const blob = new Blob([csvData], { type: "text/csv" });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "planilhaExemplo.csv");

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};

export const DownloadAddUsers = () => {
  const csvData = `\uFEFFVocê está criando uma planilha para adicionar vários usuários na sua conta de uma só vez. (Não apagar primeira e segunda linha). Preencha as informações corretamente:\r\nNome,E-mail\r\nGabriela Rocha,gabriela.rocha@email.com\r\nLucas Almeida,lucas.almeida@email.com`;

  const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "planilhaTemplate.csv");

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};
